import script from "./ErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorView.vue?vue&type=script&setup=true&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=d176104a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d176104a"]])

export default __exports__